// extracted by mini-css-extract-plugin
export default {"Dialog":"Dialog_Dialog__--unh","Dialog__content":"Dialog_Dialog__content__nEZ0K","Dialog--close":"Dialog_Dialog--close__ab2Kw"};